import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.917 0H2.083A2.086 2.086 0 0 0 0 2.083v15.834C0 19.066.935 20 2.083 20h15.834A2.086 2.086 0 0 0 20 17.917V2.083C20 .934 19.065 0 17.917 0m.416 2.083v7.084h-7.5v-7.5h7.084c.23 0 .416.187.416.416m-16.25-.416h7.084v7.5h-7.5V2.083c0-.229.186-.416.416-.416m-.416 16.25v-7.084h7.5v7.5H2.083a.417.417 0 0 1-.416-.416m16.25.416h-7.084v-7.5h7.5v7.084c0 .229-.186.416-.416.416"
    }, null, -1)
  ]))]))
}
export default { render: render }